// src/context/BookingContext.jsx
import { createContext, useContext, useState } from "react";

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    shopKey: null,  // ✅ top level, not inside customer
    customer: {
      name: "",
      mobile: "",
      email: "",
      dlDocument: null,
      aadhaarDocument: null,
    },
    booking: {
      vehicleType: "scooter",
      pickupTime: null,
      dropTime: null,
    },
  });

  return (
    <BookingContext.Provider value={{ bookingData, setBookingData }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);